import { observer } from 'mobx-react';
import { Avatar, avatarFrom } from '../../../../../../Avatar';
import { findLink } from '../../../../../../LinkyLinky';
import { Participant, ParticipantResource } from '../../../../../../ParticipantsStore/Types';
import { Link } from '../../../../../../Resource/Types';
import CloseIcon from '../../../../../Cutesies/CloseIcon';
import ParticipantAvatar from '../../../../../ParticipantAvatar';

export interface Props {
  participants: ReadonlyArray<ParticipantResource>;
  removeParticipant: (participant: ParticipantResource) => void;
}

const getAvatar = (photo: ReadonlyArray<Link>, participant: Participant): Avatar =>
  avatarFrom(findLink('avatar', photo), participant.initials);

function SelectedUser({ participants, removeParticipant }: Props) {
  return (
    <>
      {participants.map((participant) => (
        <div className="flex pt-2 justify-between items-center" key={participant.payload.id}>
          <div className="flex">
            <div className="w-8 h-8 mr-2 my-auto">
              <ParticipantAvatar avatar={getAvatar(participant.links, participant.payload)} />
            </div>
            <div className="flex flex-col">
              <div className="">{participant.payload.fullName.getOrElseValue('')}</div>
              <div className="">{participant.payload.email}</div>
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => removeParticipant(participant)}>
            <CloseIcon />
          </div>
        </div>
      ))}
    </>
  );
}

export default observer(SelectedUser);
